module.exports = __webpack_public_path__ + "69ccc292bbe1b62c226db2a5253d2fa8.png";